<script setup>
import ArrowLeft from "@/components/shared/icons/ArrowLeft.vue";
import { defineEmits } from "vue";

const { toggleMenu } = defineProps({
  description: {
    type: String,
    default: "",
  },
  route: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["toggle-sidebar"]);
</script>
<template>
  <div v-if="route && description">
    <router-link
      :to="route"
      class="flex text-cyan-200 cursor-pointer ml-1 mt-3"
    >
      <ArrowLeft customClass="w-5 h-5" />
      <span class="font-semibold text-sm">{{ description }}</span>
    </router-link>
  </div>
  <div v-else-if="description">
    <div
      @click="emit('toggle-sidebar')"
      class="flex text-cyan-200 cursor-pointer ml-1 mt-3"
    >
      <ArrowLeft customClass="w-5 h-5" />
      <span class="font-semibold text-sm">{{ description }}</span>
    </div>
  </div>
</template>
